import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchema = (isPasswordLogin: boolean) => {
  const { t } = useTranslation();

  let passwordValidation = yup.string();

  if (isPasswordLogin) {
    passwordValidation = yup.string().required(t('warning.required'));
  }

  return yup.object().shape({
    username: yup.string().required(t('warning.required')),
    password: passwordValidation,
  });
};
